export const firstNamesBase = [
    'John',
    'Mary',
    'Michael',
    'Jennifer',
    'James',
    'Linda',
    'William',
    'Elizabeth',
    'David',
    'Barbara',
    'Richard',
    'Susan',
    'Joseph',
    'Jessica',
    'Thomas',
    'Sarah',
    'Charles',
    'Karen',
    'Christopher',
    'Nancy',
    'Daniel',
    'Lisa',
    'Matthew',
    'Betty',
    'Donald',
    'Dorothy',
    'Paul',
    'Sandra',
    'Mark',
    'Ashley',
    'George',
    'Kimberly',
    'Steven',
    'Donna',
    'Edward',
    'Emily',
    'Brian',
    'Carol',
    'Ronald',
    'Michelle',
    'Jason',
    'Amanda',
    'Jeffrey',
    'Stephanie',
    'Ryan',
    'Laura',
    'Eric',
    'Rebecca',
    'Kevin',
    'Nicole',
    'Scott',
    'Angela',
    'Gregory',
    'Melissa',
    'Timothy',
    'Christine',
    'Kenneth',
    'Cynthia',
    'Jeremy',
    'Amy',
];
